import React, { useCallback, useEffect, useState } from 'react'
import {
  FormButtonGroup,
  UploadFileListWrapper,
  UploadWrapper,
} from '../../../../components/CommentComponent/CommentComponentStyled'
import { Button, message, Upload } from 'antd'
import { SendOutlined, UploadOutlined } from '@ant-design/icons'
import utils from '../../../../utils'
import MentionTextInput from '../../../../components/MentionTextInput/MentionTextInput'
import { inject, observer } from 'mobx-react'
import { toJS } from 'mobx'
import CommentComponent from '../../../../components/CommentComponent/CommentComponent'
import { DOCUMENT_TYPE, SORT_TYPE } from '../../../../constants'
import UploadFileItem from '../../../../components/Common/FileItemComponent/UploadFileItem'

const CommentBlock = props => {
  const {
    signDocumentId,
    fileStore,
    electronicDocumentStore,
    loadingAnimationStore,
    notificationStore,
  } = props
  const { notificationType } = notificationStore

  const { commentElectronicDocumentList } = electronicDocumentStore

  const [comment, setComment] = useState('')
  const [commentList, setCommentList] = useState([])
  const [sort, setSort] = useState(SORT_TYPE.DESCENDING)
  const [fileList, setFileList] = useState([])
  const [isShowDelComments, setIsShowDelComments] = useState(false)

  const handleOnchangeComment = (
    event,
    newValue,
    newPlainTextValue,
    mentions
  ) => {
    setComment(newValue)
  }
  const handleChangeSortComment = sort => {
    setSort(sort)
    const commentListReverse = commentList.reverse()
    setCommentList([...commentListReverse])
  }
  const handleRemoveFileFromUploadList = fileUID => {
    const newFileList = fileList.filter(file => file.uid !== fileUID)
    setFileList(newFileList)
  }
  const handleChangeFile = info => {
    const filteredFileList = info.fileList.filter(
      (elem, index, fileArray) =>
        fileArray.findIndex(file => file.name === elem.name) === index
    )
    setFileList(filteredFileList)
  }

  const handleCreateComment = async (id, commentData) => {
    try {
      const scrollCommentWrapper = document.querySelector('.listCommentWrapper')
      let newCommentList = [...commentList]
      await electronicDocumentStore.createCommentElectronicDocument(
        id,
        commentData
      )
      const response = await electronicDocumentStore.getCommentElectronicDocumentList(
        id
      )
      const newComment = response.data[response.data.length - 1]
      if (sort === SORT_TYPE.DESCENDING) {
        newCommentList.push(newComment)
      }
      if (sort === SORT_TYPE.ASCENDING) {
        setSort(SORT_TYPE.DESCENDING)
        newCommentList.unshift(newComment)
        newCommentList = newCommentList.reverse()
      }
      setCommentList(newCommentList)
      handleShowDeletedComment(newCommentList, isShowDelComments)
      setComment('')
      scrollCommentWrapper.scrollTo(0, scrollCommentWrapper.scrollHeight)
    } catch (err) {
      console.log(err)
      message.error(err?.vi || 'Gửi ý kiến không thành công!')
    }
  }
  const sendComment = useCallback(async () => {
    if (utils.isNullish(comment)) return
    if (comment.length > 500) {
      return message.error('Ý kiến không vượt quá 500 ký tự!')
    }
    const uploadFileList = fileList
      ? fileList.map(file => file.originFileObj)
      : []
    const batchUploadArr = []
    uploadFileList.forEach(file => {
      const formData = new FormData()
      formData.append('file', file)
      batchUploadArr.push(fileStore.uploadFile(formData))
    })
    let uploadedFiles = []
    loadingAnimationStore.setShowSpinInline(true)
    try {
      const response = await Promise.all(batchUploadArr)
      uploadedFiles = response.map(response => response.data.file_id)
      const commentData = {
        content: comment.replace(/\s+/g, ' ').trim(),
        file_ids: uploadedFiles,
      }
      if (commentData.content.trim() === '') {
        message.error('Vui lòng không để trống ý kiến.')
        return
      }
      await handleCreateComment(signDocumentId, commentData)
      setFileList([])
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.setShowSpinInline(false)
    }
  }, [fileList, commentList, comment])

  const renderCommentForm = (
    <div className={'comment-form'}>
      <MentionTextInput
        value={comment}
        readonly={false}
        onChange={handleOnchangeComment}
        placeHolder={'Viết ý kiến...'}
      />
      {fileList.length !== 0 && (
        <UploadFileListWrapper>
          {fileList.map(file => (
            <UploadFileItem
              key={file.uid}
              file_id={file.uid}
              file_name={file.name}
              file_type={utils.getExtensionFile(file.name)}
              handleRemoveFileFromUploadList={() =>
                handleRemoveFileFromUploadList(file.uid)
              }
            />
          ))}
        </UploadFileListWrapper>
      )}
      <FormButtonGroup>
        <UploadWrapper>
          <Upload
            style={{ marginLeft: 4, marginRight: 4 }}
            valuePropName={'fileList'}
            fileList={fileList}
            multiple={true}
            onChange={handleChangeFile}
            beforeUpload={() => false}
            showUploadList={false}>
            <Button htmlType={'button'}>
              <UploadOutlined /> Tải file
            </Button>
          </Upload>
        </UploadWrapper>
        <Button onClick={sendComment} type={'primary'} icon={<SendOutlined />}>
          Đăng ý kiến
        </Button>
      </FormButtonGroup>
    </div>
  )

  const handleDeleteComment = async (comment_id, index) => {
    try {
      loadingAnimationStore.setShowSpinInline(true)
      await electronicDocumentStore.deleteCommentElectronicDocument(
        signDocumentId,
        comment_id
      )
      const newCommentList = [...commentList]
      newCommentList[index] = {
        ...newCommentList[index],
        deleted: true,
      }
      setCommentList(newCommentList)
      handleShowDeletedComment(newCommentList, isShowDelComments)
      message.success('Xóa ý kiến thành công!')
    } catch (err) {
      console.log(err)
      message.error('Xóa ý kiến thất bại!')
    } finally {
      loadingAnimationStore.setShowSpinInline(false)
    }
  }

  const handleShowDeletedComment = async (id_comment, isShow) => {
    /** Danh sách comment mới gồm mảng những comment đã xóa đi */
    if (isShow) {
      // const indexOfArrDeletedComment = commentList.findIndex(
      //   cmt => cmt.comment_id === id_comment
      // )
      // commentList[indexOfArrDeletedComment] = {
      //   ...commentList[indexOfArrDeletedComment],
      //   isHidden: false,
      // }
      // const newCommentList = []
      // commentList.map(el => {
      //   if (
      //     el.comment_id === commentList[indexOfArrDeletedComment].comment_id
      //   ) {
      //     newCommentList.push(
      //       ...commentList[indexOfArrDeletedComment].arrDeletedComment
      //     )
      //   }
      //   if (
      //     el.comment_id !== commentList[indexOfArrDeletedComment].comment_id
      //   ) {
      //     newCommentList.push(el)
      //   }
      // })
      const newCommentList = []
      commentList.forEach(comment => {
        if (comment.isHidden) {
          newCommentList.push(...comment.arrDeletedComment)
          comment.isHidden = !comment.isHidden
        } else newCommentList.push(comment)
      })
      setCommentList(newCommentList)
    } else {
      await getCommentElectronicDocumentList()
    }
  }

  useEffect(() => {
    /** Danh sách comment sau khi xóa chứa các comment đã xóa liền nhau gộp thành 1 mảng */

    let commentAfterDeleteList = []
    let key = -1
    commentElectronicDocumentList.map((el, i) => {
      if (!el.deleted) {
        commentAfterDeleteList.push(toJS(el))
      }
      if (el.deleted && i > key) {
        const arrDeletedComment = []
        for (
          let index = i;
          index < commentElectronicDocumentList.length;
          index++
        ) {
          key = index
          if (commentElectronicDocumentList[index].deleted === el.deleted) {
            arrDeletedComment.push(toJS(commentElectronicDocumentList[index]))
          }
          if (
            commentElectronicDocumentList[index].deleted === !el.deleted ||
            index === commentElectronicDocumentList.length - 1
          )
            break
        }
        commentAfterDeleteList.push({
          comment_id: arrDeletedComment[0].comment_id,
          arrDeletedComment: arrDeletedComment,
          isHidden: true,
        })
      }
    })
    setCommentList(commentAfterDeleteList)
  }, [commentElectronicDocumentList])

  const getCommentElectronicDocumentList = async () => {
    try {
      loadingAnimationStore.setShowSpinInline(true)
      const scrollCommentWrapper = document.querySelector('.listCommentWrapper')
      await electronicDocumentStore.getCommentElectronicDocumentList(
        signDocumentId
      )
      await scrollCommentWrapper.scrollTo(0, scrollCommentWrapper.scrollHeight)
    } catch (err) {
      console.log(err)
      message.error(err?.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.setShowSpinInline(false)
    }
  }

  useEffect(() => {
    if (!signDocumentId) return
    if (!utils.isIOSDevice()) {
      const channel4Broadcast = new BroadcastChannel('channel4')
      channel4Broadcast.onmessage = async even => {
        if (
          even.data.type === DOCUMENT_TYPE.ELEC_DOC &&
          even.data.code === signDocumentId
        ) {
          await getCommentElectronicDocumentList()
        }
      }
    }
  }, [signDocumentId])

  useEffect(() => {
    if (!signDocumentId) return /** Check thiết bị IOS */
    ;(async () => {
      if (
        utils.isIOSDevice() &&
        notificationType &&
        notificationType.type === DOCUMENT_TYPE.ELEC_DOC
      ) {
        await getCommentElectronicDocumentList()
      }
    })()
  }, [signDocumentId, notificationType])

  useEffect(() => {
    if (!signDocumentId) return
    ;(async () => {
      await getCommentElectronicDocumentList()
    })()
  }, [signDocumentId])
  const handleToggleShowDelCommentsMenu = () => {
    handleShowDeletedComment(commentList, !isShowDelComments)
    setIsShowDelComments(!isShowDelComments)
  }

  return (
    <CommentComponent
      handleToggleShowDelCommentsMenu={handleToggleShowDelCommentsMenu}
      handleDeleteComment={handleDeleteComment}
      commentList={commentList}
      isShowDelComments={isShowDelComments}
      handleShowDeletedComment={handleShowDeletedComment}
      renderCommentForm={renderCommentForm}
      handleChangeSortComment={handleChangeSortComment}
      sortComment={sort}
    />
  )
}

CommentBlock.propTypes = {}
export default inject(
  'fileStore',
  'loadingAnimationStore',
  'electronicDocumentStore',
  'notificationStore'
)(observer(CommentBlock))
